import { Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 28px",
    width: 820,
    // height: 500,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    marginTop: theme.spacing(2),
  },
  listItem: {
    color: "#172b4d",
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
  red: {
    color: theme.palette.error.main,
  },
}));

function ExtensionInfo() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContentTitle title="SMART VISA Extension" />
      <Typography variant="body2" className={classes.label}>
        Information: Smart Visa holders wishing to extend their permission to
        stay under Smart Visa must apply for a renewal of qualification
        endorsement at least 60 days before the expiry of Smart Visa.
      </Typography>
      <Typography variant="body2" className={classes.label}>
        After being notified of the result of qualification endorsement, the
        Smart visa holders must proceed with making an appointment for Smart
        Visa extension issuance at the Immigration Bureau at One Stop Service
        Center for Visa and Work Permit (OSS){" "}
        <span className={classes.red}>*</span>,18th Floor, Chamchuri Square
        Building, Bangkok before the expiry of the current Smart Visa.
      </Typography>
      <Typography variant="body2" className={classes.label}>
        Documents needed to be presented at the time of Smart Visa extension are
        as follows <span className={classes.red}>**.</span>
      </Typography>

      <ol type="a">
        <Typography variant="body2" component="li" className={classes.listItem}>
          Passport or travel document and a copy of all passport or travel
          document pages with immigration or consular stamps
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          NOTIFICATION LETTER from the Board of Investment to the Immigration
          Bureau within 60 days from issuance date of the endorsement letter
          (PRINT ONE SIDED)
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          <Link
            href="https://smart-visa.boi.go.th/smart/document/related/TM7.pdf"
            target="_blank"
          >
            TM7 Form – APPLICATION FOR EXTENSION OF TEMPORARY STAY IN THE
            KINGDOM (PRINT ON BOTH SIDES)
          </Link>
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          <Link
            href="https://smart-visa.boi.go.th/smart/document/related/TM8.pdf"
            target="_blank"
          >
            TM8 Form – ACKNOWLEDGEMENT OF TERMS AND CONDITIONS FOR PERMIT OF
            TEMPORARY STAY IN THE KINGDOM OF THAILAND (PRINT ON BOTH SIDES)
          </Link>
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          <Link
            href="https://smart-visa.boi.go.th/smart/document/related/STM6.pdf"
            target="_blank"
          >
            STM6 Form – CRITERIA AND CONDITIONS ACKNOWLEDGEMENT FORM FOR THE
            TEMPORARY STAY PERMIT IN THE KINGDOM (SMART VISA) (PRINT ON BOTH
            SIDES) – CRITERIA AND CONDITIONS ACKNOWLEDGEMENT FORM FOR THE
            TEMPORARY STAY PERMIT IN THE KINGDOM (SMART VISA) (PRINT ON BOTH
            SIDES) WITH STAMP
          </Link>
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          <Link
            href="https://smart-visa.boi.go.th/smart/document/related/THE%20ACKNOWLEDGEMENT.pdf"
            target="_blank"
          >
            THE ACKNOWLEDGEMENT FORM OF PENALTIES FOR A VISA OVERSTAY ( PRINT
            ONE SIDED)
          </Link>
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          <Link
            href="https://smart-visa.boi.go.th/smart/document/related/The%20Acknowledgement%20of%20Practices%20for%20Recipients%20of%20Smart%20Visa.pdf"
            target="_blank"
          >
            THE ACKNOWLEDGEMENT OF PRACTICES FOR RECIPIENTS OF SMART VISA (PRINT
            ONE SIDED)
          </Link>
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          T.M. 6 Card
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          1-Year notification card
        </Typography>
        <Typography variant="body2" component="li" className={classes.listItem}>
          Two passport size photo (4cm x 6cm) White background, without wearing
          glasses or headgear, taken within 6 months (a photocopy or poor
          quality photos will not be accepted)
        </Typography>
      </ol>
      <Typography variant="body2" className={classes.label}>
        <span className={classes.red}>*</span> If you are not in Thailand at the
        time of Smart Visa extension, you can inform Smart Visa unit of the
        situation and collect Smart Visa sticker at Royal Thai Embassy/
        Consulate-General overseas before entering Thailand.
      </Typography>
      <Typography variant="body2" className={classes.label}>
        <span className={classes.red}>**</span> The processing fee is 10,000
        Baht per year of visa permission (cash only), for example the permitted
        duration of 1 year 4 months will cost 20,000 Baht and has to be paid to
        the Immigration at the time of visa extension.
      </Typography>
      <div style={{ height: 54 }} />
    </div>
  );
}

function ChangeSmartInfo({ onClose = () => {} }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContentTitle title="SMART VISA Qualifications Update" />
      <Typography variant="body2" className={classes.label}>
        Information: Smart Visa holders must report the changes in working
        conditions or investment as follows to the Smart Visa unit as soon as
        possible.
      </Typography>

      <ol type="1">
        {[
          "Changing of a position, job title, responsibility, or assignment within the same company",
          "Additional employment (working for another endorsed company, employer, or sponsor)",
          "Additional company in which Smart “I” holder invests in or adjustment of investment portfolio",
          "Changing of the company adress",
          "Changing of company name under the same juristic ID",
          "Adjustment of company shares owned by Smart “S” holder",
        ].map((text) => (
          <Typography
            variant="body2"
            component="li"
            className={classes.listItem}
            key={text}
          >
            {text}
          </Typography>
        ))}
      </ol>

      <div style={{ height: 54 }} />
    </div>
  );
}
function StatusReportInfo({ onClose = () => {} }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContentTitle title="SMART VISA Status Report" />
      <Typography variant="body2" className={classes.label}>
        Information: Smart Visa holders must report their status and eligibility
        for Smart Visa to the Smart Visa unit on a yearly basis counting from
        the issuance date of the notification letter
        <span className={classes.red}>*</span>
      </Typography>
      <Typography variant="body2" className={classes.label}>
        The required documents are as follows.
      </Typography>

      <ol type="1">
        {[
          "All Smart Visa: STATUS REPORT FORM OF THE SMART VISA HOLDER",
          "Smart “T” and “E”: Evidence of payment of annual income tax (such as PND91, PND90, or PND1 of the latest three months) or tax return documents (in case the income is paid by a company overseas).",
          "Smart “I” and “S”: Copy of the list of shareholders (not more than 3 months old) or/and a transfer receipt of the capital investment.",
          "Smart “S”: Foreign Business License or Foreign Business Certificate (in case of a foreign majority company in restricted business activities under the Foreign Business Act).",
        ].map((text) => (
          <Typography
            variant="body2"
            component="li"
            className={classes.listItem}
            key={text}
          >
            {text}
          </Typography>
        ))}
      </ol>

      <Typography
        variant="body2"
        className={classes.label}
        style={{ fontStyle: "oblique" }}
      >
        <span className={classes.red}>*</span>Online 1-year Status report to
        Smart Visa unit is not the same as 1-year report of the current address
        to the Immigration. 1-Year report of the current address to the
        Immigration must be done on a yearly basis counting from Smart Visa
        issuance date. This report can be done 15 days before or 7 days after
        the date specified on 1-year report notification card. However, in the
        case of re-entering the Kingdom, the report is due in one year from the
        date of the latest arrival. (If Smart Visa is issued at Royal Thai
        Embassy/ Consulate-General, Smart Visa holders will not receive a 1-year
        report notification card. In such case, the report of current address to
        the Immigration will be due in 1 year from the latest arrival date
        specified on the arrival stamp.)
      </Typography>

      <div style={{ height: 54 }} />
    </div>
  );
}

function CancelInfo({ onClose = () => {} }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContentTitle
        title="SMART VISA Termination"
      />
      <Typography variant="body2" className={classes.label}>
        Information: Smart Visa holders who would like to terminate Smart Visa
        or have resigned from a company before Smart Visa expires* must make a
        request for Smart Visa termination letter by uploading the required
        documents (such as a termination letter of employment issued by the
        employer) to receive a notification letter of Smart Visa termination and
        submit to the Immigration at One Stop Service Center for Visa and Work
        Permit (OSS),18th Floor, Chamchuri Square Building, Bangkok.
        <br />
        After the Smart Visa termination, the foreigner is advised to leave the
        country or change to other types of visa before the end date of
        permission to stay in Thailand, as appeared on the termination stamp.
      </Typography>
      <Typography variant="body2" className={classes.label}>
        <span className={classes.red}>*</span>Smart Visa holders can still
        request for an official document to support their Smart Visa termination
        after the expiration of Smart Visa.
      </Typography>

      <div style={{ height: 54 }} />
    </div>
  );
}

export default function SmartTypeInfo({ type = "", onClose = () => {} }) {

  const classes = useStyles();

  const getInfoComponents = () => {
    switch (type) {
      case "extension":
        return <ExtensionInfo />;
      case "change":
        return <ChangeSmartInfo />;
      case "statusReport":
        return <StatusReportInfo />;
      case "cancel":
        return <CancelInfo />;
      default:
        return null;
    }
  };

  return (
    <div>
      {getInfoComponents()}
      <ColorButton
        fullWidth
        color={"primary"}
        variant="outlined"
        onClick={onClose}
      >
        Close
      </ColorButton>
      <div style={{ height: 34 }} />
    </div>
  );
}
